import React, { useState, useEffect } from 'react';
import { translate } from 'react-multi-lang';
import { SyncOutlined, LeftOutlined, AlertFilled, CloseOutlined, PauseOutlined, MinusOutlined, CopyOutlined } from '@ant-design/icons';

import {Form, Row, Col, Button, Input, InputNumber, DatePicker, Select, Divider, Switch, Space, Tooltip, message } from 'antd';

import TextAreaCount from './../../TextAreaCount';
import ImatgeDNI from './../../ImatgeDNI';
import VisorImatges from "./../../visorImatges";


import moment from 'moment';
import 'moment/locale/ca';
import 'moment/locale/es';

import locale_ca from 'antd/es/date-picker/locale/ca_ES';
import locale_en from 'antd/es/date-picker/locale/en_GB';
import locale_es from 'antd/es/date-picker/locale/es_ES';

import { AllHtmlEntities } from 'html-entities';

import { Api, HtmlStrings } from '../../../helpers';

const entities = new AllHtmlEntities();

function Empresa(props){

  const [id, setId] = useState(props.item.id);
  const [id_categoria, setId_categoria] = useState(props.item.id_categoria);
  const [nom, setNom] = useState(entities.decode(props.item.nom));
  const [descripcio_ca, setDescripcio_ca] = useState(entities.decode(props.item.descripcio_ca));
  const [descripcio_en, setDescripcio_en] = useState(entities.decode(props.item.descripcio_en));
  const [descripcio_es, setDescripcio_es] = useState(entities.decode(props.item.descripcio_es));
  const [oferta_ca, setOferta_ca] = useState(entities.decode(props.item.oferta_ca));
  const [oferta_en, setOferta_en] = useState(entities.decode(props.item.oferta_en));
  const [oferta_es, setOferta_es] = useState(entities.decode(props.item.oferta_es));
  const [telefon, setTelefon] = useState(props.item.telefon);
  const [email, setEmail] = useState(props.item.email);
  const [web, setWeb] = useState(props.item.web);
  const [persona_contacte, setPersona_contacte] = useState(entities.decode(props.item.persona_contacte));
  const [adress, setAdress] = useState(entities.decode(props.item.adress));
  const [cp, setCp] = useState(props.item.cp);
  const [ciutat, setCiutat] = useState(entities.decode(props.item.ciutat));
  const [logo, setLogo] = useState(props.item.logo);
  const [fini, setFini] = useState(props.item.fini);
  const [ffin, setFfin] = useState(props.item.ffin);
  const [noCaduca, setNoCaduca] = useState((fini!==null && ffin!=null) ? false : true);
  const [visible, setVisible] = useState(props.item.visible === 1);


  const [dni_image_1_dataUrl, setDni_image_1_dataUrl ] = useState(undefined);
  const [visor, setVisor] = useState({visible: false});

  const [categoriesOptions, setCategoriesOptions] = useState([]);

  const [guardant, setGuardant] = useState(false);
  const [errorCategoria, setErrorCategoria] = useState('');
  const [errorNom, setErrorNom] = useState('');

  const [nou, setNou] = useState(props.item.id===0);


  useEffect(() => {
    buscarDadesCategoria();
  },[props]);

  useEffect(() => {
    if(id_categoria && id_categoria > 0){
      setErrorCategoria('');
    }
  },[id_categoria]);

  useEffect(() => {
    console.log('props.item',props.item)
    setId(props.item.id);
    setNou(props.item.id===0)
    setId_categoria(props.item.id_categoria);
    setNom(entities.decode(props.item.nom));
    setDescripcio_ca(entities.decode(props.item.descripcio_ca));
    setDescripcio_en(entities.decode(props.item.descripcio_en));
    setDescripcio_es(entities.decode(props.item.descripcio_es));
    setOferta_ca(entities.decode(props.item.oferta_ca));
    setOferta_en(entities.decode(props.item.oferta_en));
    setOferta_es(entities.decode(props.item.oferta_es));
    setTelefon(props.item.telefon);
    setEmail(props.item.email);
    setWeb(props.item.web);
    setPersona_contacte(entities.decode(props.item.persona_contacte));
    setAdress(entities.decode(props.item.adress));
    setCp(props.item.cp);
    setCiutat(entities.decode(props.item.ciutat));
    setLogo(props.item.logo);
    setFini(props.item.fini);
    setFfin(props.item.ffin);
    setNoCaduca((fini!==null && ffin!=null) ? false : true);
    setVisible(props.item.visible);

  },[props.item]);




  const buscarDadesCategoria = async () => {
      const cat = await Api.get('/empreses/categories');
      if(cat.result.success===1){
        console.log('Categories: ',cat)
        const llista_cat = cat.data.categories.map((item) =>{
              return(
                <Select.Option key={item.id} value={item.id}>
                  {entities.decode(eval('item.nom_'+props.t('idioma')))}
                </Select.Option>
              );
        });
        setCategoriesOptions(llista_cat);
      }
    }

  const calendarChange = (rang_moments, rang_strings) => {
    setFini(rang_moments[0].toISOString());
    setFfin(rang_moments[1].toISOString());
  }

  const populate_desc = (id) =>{
    const x = eval('descripcio_'+id);

    if(id !=='ca') setDescripcio_ca(x);
    if(id !=='en') setDescripcio_en(x);
    if(id !=='es') setDescripcio_es(x);
  }
  const populate_oferta = (id) =>{
    const x = eval('oferta_'+id);

    if(id !=='ca') setOferta_ca(x);
    if(id !=='en') setOferta_en(x);
    if(id !=='es') setOferta_es(x);
  }

  const submitForm = async (values) => {

    let correcte = true;

    if(!id_categoria && id_categoria < 1){
      setErrorCategoria('error');
      correcte = false;
    }

    if(nom.length === 0){
      setErrorNom('error');
      correcte = false;
    }

    if(!correcte){
      return false;
    }
    setGuardant(true);
    let dades = {
      id,
      id_categoria,
      nom: entities.encode(nom.trim()),
      descripcio_ca: entities.encode(descripcio_ca.trim()),
      descripcio_en: entities.encode(descripcio_en.trim()),
      descripcio_es: entities.encode(descripcio_es.trim()),
      oferta_ca: entities.encode(oferta_ca.trim()),
      oferta_en: entities.encode(oferta_en.trim()),
      oferta_es: entities.encode(oferta_es.trim()),
      telefon: telefon.length > 0 ? telefon.trim() : '',
      email,
      web: web.length > 0 ? web.trim() : '',
      persona_contacte: entities.encode(persona_contacte),
      adress: entities.encode(adress),
      cp,
      ciutat: entities.encode(ciutat),
      logo: logo ? logo.trim() : '',
      fini: noCaduca === true ? '' : fini,
      ffin: noCaduca === true ? '' : ffin,
      visible
    }

    let method = nou?'POST':'PUT';
    let url_api = nou? '/empreses' : '/empreses/'+id;

    try{
      console.log('method: ', method)
      console.log('Dades myFetch', dades)
      const resposta = await Api.myFetch(url_api, method, JSON.stringify(dades));
      if(resposta.result.success === 1){

        if(dni_image_1_dataUrl !== undefined){
          const blob = await (await fetch(dni_image_1_dataUrl)).blob();
          let form_imatges = new FormData();
          form_imatges.append("imgFileField", blob, "image.jpg");
          let resp = await Api.myFetch('/empreses/logo/'+resposta.data.id, 'POST', form_imatges);
            if(resp.result.success === 1){
              console.log(resp);
              setLogo(resp.data.logo);
            }else{
              console.error('Error POST file: Empreses Logo: ',resp);
              message.config({top: 50});
              message.open({content: resp.data.message, duration:5});
            }
        }



        setGuardant(false);
        message.success(props.t('generic.OK_saved'), 5);
        props.callback();
      }else{
        setGuardant(false);
        console.error('Error: submit Empresa: ',resposta);
        message.config({top: 50});
        message.open({content: resposta.data.message, duration:10});
      }
    }catch(error){
      setGuardant(false);
      message.config({top: 50});
      message.open({content: "Error saving", duration:10});
      console.error('Error: Empresa: ', error);
    }

  }


  let defaultDataRange = '';
  if(nou){
    defaultDataRange=[
      moment.utc(new Date()),
      moment.utc(new Date())
    ];

  }
  if (fini!=null && ffin!=null){
      defaultDataRange=[
        moment(fini),
        moment(ffin)
      ];
  }


  let localeDatePicker;
  switch (props.t('idioma')) {
    case 'ca':
      localeDatePicker = locale_ca;
      break;
    case 'en':
      localeDatePicker = locale_en;
      break;
    case 'es':
      localeDatePicker = locale_es;
      break;
    default:
      localeDatePicker = locale_ca;
  }
  const dateFormat = 'DD/MM/YYYY HH:mm';
{/*.tz('Europe/Madrid')*/}
  return(
    <div>
    <Form onFinish={submitForm}
      layout="vertical"
      autoComplete="off"
    >

    <Form.Item
      validateStatus={errorNom}
      label={props.t('botiga.nom')}
      required={true}
    >
      <TextAreaCount autoSize={{ minRows: 1, maxRows: 2 }} maxLength={256} name="nom" placeholder={props.t('botiga.nom')} onChange={setNom} value={nom}/>
    </Form.Item>

    <Form.Item style={{marginBottom: 10}} label={props.t('medic.categoria')} validateStatus={errorCategoria} required={true}>
      <Select defaultValue={id_categoria} value={id_categoria} onChange={setId_categoria}>
        {categoriesOptions}
      </Select>
    </Form.Item>

    <Form.Item style={{marginBottom: 10}}>
      <Switch checkedChildren={props.t('generic.visible')} unCheckedChildren={props.t('generic.no_visible')} onChange={setVisible} checked={visible} style={{marginLeft: '5px'}}/>
    </Form.Item>


    <Form.Item
      label={props.t('botiga.fini_fin')}
      required={true}
    >
      <DatePicker.RangePicker
        defaultValue={defaultDataRange}
        //showTime={{ format: 'HH:mm' }}
        showTime={{ format: 'HH:mm', defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }}
        placeholder={[props.t('botiga.fini'), props.t('botiga.ffin')]}
        format={dateFormat}
        locale={localeDatePicker}
        disabled={noCaduca}
        onChange={calendarChange}
      />
      <Switch checkedChildren={props.t('botiga.nocaduca')} unCheckedChildren={props.t('botiga.caduca')} onChange={setNoCaduca} defaultChecked={noCaduca} style={{marginLeft: '5px'}}/>
    </Form.Item>

    <Row>

    <Col span={8} key='descripcio_ca'>
      <Form.Item
        label={props.t('botiga.descripcio')+' CA'}
      >
        <Row style={{marginRight:'10px'}}>
          <Col flex="auto">
            <TextAreaCount autoSize={{ minRows: 4, maxRows: 50 }} maxLength={2048} name="descripcio_ca" placeholder={props.t('botiga.descripcio')} onChange={setDescripcio_ca} value={descripcio_ca}/>
          </Col>
          <Col flex="32px">
              <Tooltip title={props.t('generic.copiar_als_altres')}>
                <Button shape="circle" icon={<CopyOutlined />} onClick={(e)=>populate_desc('ca')}/>
              </Tooltip>
          </Col>
        </Row>
      </Form.Item>
      <Form.Item
        label={props.t('empreses.oferta')+' CA'}
      >
        <Row style={{marginRight:'10px'}}>
          <Col flex="auto">
            <TextAreaCount autoSize={{ minRows: 4, maxRows: 25 }} maxLength={1024} name="oferta_ca" placeholder={props.t('empreses.oferta')} onChange={setOferta_ca} value={oferta_ca}/>
          </Col>
          <Col flex="32px">
              <Tooltip title={props.t('generic.copiar_als_altres')}>
                <Button shape="circle" icon={<CopyOutlined />} onClick={(e)=>populate_oferta('ca')}/>
              </Tooltip>
          </Col>
        </Row>
      </Form.Item>
    </Col>
    <Col span={8} key='descripcio_en'>
      <Form.Item
        label={props.t('botiga.descripcio')+' EN'}
      >
        <Row style={{marginRight:'10px'}}>
          <Col flex="auto">
            <TextAreaCount autoSize={{ minRows: 4, maxRows: 50 }} maxLength={2048} name="descripcio_en" placeholder={props.t('botiga.descripcio')} onChange={setDescripcio_en} value={descripcio_en}/>
          </Col>
          <Col flex="32px">
              <Tooltip title={props.t('generic.copiar_als_altres')}>
                <Button shape="circle" icon={<CopyOutlined />} onClick={(e)=>populate_desc('en')}/>
              </Tooltip>
          </Col>
        </Row>
      </Form.Item>
      <Form.Item
        label={props.t('empreses.oferta')+' EN'}
      >
        <Row style={{marginRight:'10px'}}>
          <Col flex="auto">
            <TextAreaCount autoSize={{ minRows: 4, maxRows: 25 }} maxLength={1024} name="oferta_en" placeholder={props.t('empreses.oferta')} onChange={setOferta_en} value={oferta_en}/>
          </Col>
          <Col flex="32px">
              <Tooltip title={props.t('generic.copiar_als_altres')}>
                <Button shape="circle" icon={<CopyOutlined />} onClick={(e)=>populate_oferta('en')}/>
              </Tooltip>
          </Col>
        </Row>
      </Form.Item>
    </Col>
    <Col span={8} key='descripcio_es'>
      <Form.Item
        label={props.t('botiga.descripcio')+' ES'}
      >
        <Row style={{marginRight:'10px'}}>
          <Col flex="auto">
            <TextAreaCount autoSize={{ minRows: 4, maxRows: 50 }} maxLength={2048} name="descripcio_es" placeholder={props.t('botiga.descripcio')} onChange={setDescripcio_es} value={descripcio_es}/>
          </Col>
          <Col flex="32px">
              <Tooltip title={props.t('generic.copiar_als_altres')}>
                <Button shape="circle" icon={<CopyOutlined />} onClick={(e)=>populate_desc('es')}/>
              </Tooltip>
          </Col>
        </Row>
      </Form.Item>
      <Form.Item
        label={props.t('empreses.oferta')+' ES'}
      >
        <Row style={{marginRight:'10px'}}>
          <Col flex="auto">
            <TextAreaCount autoSize={{ minRows: 4, maxRows: 25 }} maxLength={1024} name="oferta_es" placeholder={props.t('empreses.oferta')} onChange={setOferta_es} value={oferta_es}/>
          </Col>
          <Col flex="32px">
              <Tooltip title={props.t('generic.copiar_als_altres')}>
                <Button shape="circle" icon={<CopyOutlined />} onClick={(e)=>populate_oferta('es')}/>
              </Tooltip>
          </Col>
        </Row>
      </Form.Item>
    </Col>
    </Row>

    <Row>
      <Col>
        <Form.Item label="Persona de contacte">
          <Input name="persona_contacte" placeholder="Persona de contacte" onChange={(e) => setPersona_contacte(e.target.value)} value={persona_contacte}/>
        </Form.Item>
      </Col>
      <Col>
        <Form.Item label={props.t('contacto.telefono')} style={{width: '200px'}}>
          <Input name="telefon" placeholder={props.t('contacto.telefono')} onChange={(e) => setTelefon(e.target.value)} value={telefon}/>
        </Form.Item>
      </Col>
      <Col>
        <Form.Item label={props.t('contacto.email')}>
            <Input name="email" placeholder={props.t('contacto.email')} onChange={(e) => setEmail(e.target.value)} value={email}/>
        </Form.Item>
      </Col>
    </Row>
    <Row>
      <Col span="12">
        <Form.Item label={props.t('contacto.direccion')}>
          <Input name="adress" placeholder={props.t('contacto.direccion')} onChange={(e) => setAdress(e.target.value)} value={adress}/>
        </Form.Item>
      </Col>
      <Col span="3">
        <Form.Item label={props.t('contacto.cp')}>
            <Input name="cp" placeholder={props.t('contacto.cp')} onChange={(e) => setCp(e.target.value)} value={cp}/>
        </Form.Item>
      </Col>
      <Col span="3">
        <Form.Item label={props.t('contacto.ciudad')}>
          <Input name="ciudad" placeholder={props.t('contacto.ciudad')} onChange={(e) => setCiutat(e.target.value)} value={ciutat}/>
        </Form.Item>
      </Col>
    </Row>
    <Row>
      <Col span="24">
        <Form.Item label="Web">
          <Input name="adress" placeholder="https://" onChange={(e) => setWeb(e.target.value)} value={web}/>
        </Form.Item>
      </Col>
    </Row>

    <Row>
      <Col span="6">
        <ImatgeDNI
          image={logo}
          title="Logo"
          dataUrl={dni_image_1_dataUrl}
          setDataUrl={setDni_image_1_dataUrl}
          setVisor={setVisor}
        />
      </Col>
    </Row>

    <Row type="flex" justify="center" style={{marginTop: 25, marginBottom: 25}}>
      <Col>
        <Button onClick={props.callback}>{props.t('generic.cancel')}</Button>
      </Col>
      <Col style={{marginLeft:'10px'}}>
        <Button type="primary" htmlType="submit" loading={guardant}>{props.t('generic.save')}</Button>
      </Col>
    </Row>
    </Form>

    { !visor.visible
        ? null
        : <VisorImatges image={visor.image} title={visor.title} onClose={() => setVisor({visible:false})} clickOutsideToExit={true}/>
    }
    </div>
  );

}
export default translate(Empresa);
